const styles = theme => ({
  root: {
    marginRight:24,
    marginLeft: 12,
    [theme.breakpoints.up('sm')]: {
      marginRight:32,
      marginLeft: 20,
    },
    [theme.breakpoints.up('md')]: {
      marginRight:60,
      marginLeft: 48,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Start/styles.js